/**
 * Created by mateimisarca on 25.03.2021
 */

import SeriesAddPage from './series-add-page';

export default SeriesAddPage;
